module.exports = __webpack_public_path__ + "png/quick-registration-photo-2.png?0ec07f6053edaf607bf0a59a5d430202";